import { Injectable, computed, inject } from '@angular/core';
import { InstagramService } from '@core/services/admin/instagram.service';
import { PageFiltersState } from '../store/page-filters.store';
import dayjs from 'dayjs';

@Injectable({ providedIn: 'root' })
export class SocialSharedService {
    #igS = inject(InstagramService);

    availableDates = this.#igS.availableDateRange;
    hasNoIgData = computed(() => this.computeHasNoIgData());

    setInitDates(state: PageFiltersState) {
        const startDate = this.#igS.igAccount()?.data_init_date;
        const endDate = this.#igS.igAccount()?.data_end_date;

        if (startDate && endDate) state.selectedDates.set(this.#getInitDates(startDate, endDate));
    }

    #getInitDates(startDate: string, endDate: string) {
        const oneMonthAgo = dayjs(endDate).subtract(1, 'month');
        const start = new Date(startDate);
        const end = new Date(endDate);
        const dateRange = oneMonthAgo.isBefore(dayjs(startDate))
            ? { startDate: start, endDate: end }
            : { startDate: oneMonthAgo.toDate(), endDate: end };
        return dateRange;
    }

    computeHasNoIgData() {
        const hasMadeReq = this.#igS.hasReqIgData();
        const hasIgData =
            this.#igS.igAccount()?.data_init_date && this.#igS.igAccount()?.data_end_date;

        return !!(hasMadeReq && !hasIgData);
    }
}
